import React, { useEffect, useState } from 'react';
import close_button from '../../../assets/close_button.png';
import QmModuleStyle from '../styles/qm.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);

const RevenueGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, isResult, summaryGraphData, attempt }) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [RevenueData, setRevenueData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [CostsData, setCostsData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [xAxisMinMax, setXAxisMinMax] = useState({ "monthly": { min: 1, max: 31 }, "quarterly": { min: 0, max: 3 }, "yearly": { min: 0, max: 12 } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [revenueGraphLabel, setRevenueGraphLabel] = useState("");
  const [chart, setChart] = useState(null);


  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  // let RevenueData = {
  //   "monthly": [],
  //   "yearly": [],
  //   "quarterly": []
  // }
  // let CostsData = {
  //   "monthly": [],
  //   "yearly": [],
  //   "quarterly": []
  // }
  const setGraphData = () => {
    if (chart != undefined) {
      let revenueMonthlyData = [];
      let revenueQuarterlyData = [];
      let revenueYearlyData = [];
      let costMonthlyData = [];
      let costQuaerterlyData = [];
      let costYearlyData = [];
      let monthDays = 0;
      let newPoint = "";
      let existingData = "";
      let newData = "";
      let date = new Date();
      chart?.yAxis != undefined && chart?.yAxis[0]?.update({ min: 0, max: undefined });
      switch (type) {
        case "monthly":
          revenueMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm === simObj?.laststate?.statemonth) {
              return true;
            }
          });
          revenueMonthlyData = (revenueMonthlyData != undefined ? revenueMonthlyData : []).map((data) => {
            return {
              x: data.sd,
              y: data.rv,
              date: getDate(data.cd),
              revenue: data.rv,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            monthly: revenueMonthlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            monthly: { min: 1, max: new Date(date.getFullYear(), date.getMonth(), 0).getDate() }
          }));
          if (chart?.series != undefined && revenueMonthlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueMonthlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            // newData = [...existingData, revenueMonthlyData[revenueMonthlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueMonthlyData[revenueMonthlyData.length - 1].x) {
                  existingData[index] = revenueMonthlyData[revenueMonthlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueMonthlyData[revenueMonthlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }
          (revenueMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          //Cost Data
          costMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm === simObj?.laststate?.statemonth) {
              return true;
            }
          });
          costMonthlyData = (costMonthlyData != undefined ? costMonthlyData : []).map((data) => {
            return {
              x: data.sd,
              y: data.ct,
              cost: Math.round(data.ct),
              date: getDate(data.cd),
              costOfInternalFailures: Math.round(data.ci),
              costOfExternalFailures: data.cce,
              costOfPreventiveInvestment: data.cp,
              costOfAppraisal: data.ca,
              costOfotherInvestment: data.crh
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            monthly: costMonthlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            monthly: { min: 1, max: new Date(date.getFullYear(), date.getMonth(), 0).getDate() }
          }));

          if (chart?.series != undefined && costMonthlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costMonthlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[1]?.options?.data : [];
            // newData = [...existingData, costMonthlyData[costMonthlyData.length - 1]];

            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costMonthlyData[costMonthlyData.length - 1].x) {
                  existingData[index] = costMonthlyData[costMonthlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costMonthlyData[costMonthlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[1]?.setData(newData);
          }
          (simObj?.laststate?.stateyear != undefined && simObj?.laststate?.statemonth != undefined) && (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({ min: 1, max: getMonthDays(simObj?.laststate?.stateyear, simObj?.laststate?.statemonth) });
          (costMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "quarterly":
          revenueQuarterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm >= simObj?.laststate?.statemonth - 2) {
              return true;
            }
          });
          revenueQuarterlyData = (revenueQuarterlyData != undefined ? revenueQuarterlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.rv,
              date: getDate(data.cd),
              revenue: data.rv,

            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            quarterly: revenueQuarterlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            quarterly: { min: simObj?.laststate?.statemonth - 3, max: simObj?.laststate?.statemonth }
          }));

          if (chart?.series != undefined && revenueQuarterlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueQuarterlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            // newData = [...existingData, revenueQuarterlyData[revenueQuarterlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueQuarterlyData[revenueQuarterlyData.length - 1].x) {
                  existingData[index] = revenueQuarterlyData[revenueQuarterlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueQuarterlyData[revenueQuarterlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }

            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }

          (revenueQuarterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });

          //Cost Data
          costQuaerterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm >= simObj?.laststate?.statemonth - 2) {
              return true;
            }
          });
          costQuaerterlyData = (costQuaerterlyData != undefined ? costQuaerterlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.ct,
              cost: Math.round(data.ct),
              date: getDate(data.cd),
              costOfInternalFailures: Math.round(data.ci),
              costOfExternalFailures: data.cce,
              costOfPreventiveInvestment: data.cp,
              costOfAppraisal: data.ca,
              costOfotherInvestment: data.crh
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            quarterly: costQuaerterlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            quarterly: { min: simObj?.laststate?.statemonth - 3, max: simObj?.laststate?.statemonth }
          }));

          if (chart?.series != undefined && costQuaerterlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costQuaerterlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[1]?.options?.data : [];
            // newData = [...existingData, costQuaerterlyData[costQuaerterlyData.length - 1]];

            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costQuaerterlyData[costQuaerterlyData.length - 1].x) {
                  existingData[index] = costQuaerterlyData[costQuaerterlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costQuaerterlyData[costQuaerterlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            chart?.series != undefined && chart?.series[1]?.setData(newData);
          }
          // if ((simObj?.laststate?.statemonth - 1) % 3 == 0) {
          //   chart?.xAxis[0]?.update({
          //     min: simObj.laststate.statemonth - 1,
          //     max: simObj.laststate.statemonth + 2
          //   });
          // }
          let min = 0, max = 0;
          if (simObj?.laststate?.statemonth / 3 >= 0 && simObj?.laststate?.statemonth / 3 <= 1) {
            min = 0;
            max = 3;
          }
          else if (simObj?.laststate?.statemonth / 3 > 1 && simObj?.laststate?.statemonth / 3 <= 2) {
            min = 3;
            max = 6;
          }
          else if (simObj?.laststate?.statemonth / 3 > 2 && simObj?.laststate?.statemonth / 3 <= 3) {
            min = 6;
            max = 9;
          }
          else if (simObj?.laststate?.statemonth / 3 > 3 && simObj?.laststate?.statemonth / 3 <= 4) {
            min = 9;
            max = 12;
          }
          (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({
            // min: simObj.laststate.statemonth-1,
            // max: simObj.laststate.statemonth+2
            min: min,
            max: max
          });
          (costQuaerterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "yearly":
          revenueYearlyData = simObj?.graphdata;
          revenueYearlyData = (revenueYearlyData != undefined ? revenueYearlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.rv,
              date: getDate(data.cd),
              revenue: data.rv,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            yearly: revenueYearlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            yearly: { min: 0, max: 12 }
          }));

          if (chart?.series != undefined && revenueYearlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            // newData = [...existingData, revenueYearlyData[revenueYearlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueYearlyData[revenueYearlyData.length - 1].x) {
                  existingData[index] = revenueYearlyData[revenueYearlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueYearlyData[revenueYearlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }
          (revenueYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          //Cost Data
          costYearlyData = simObj?.graphdata;
          costYearlyData = (costYearlyData != undefined ? costYearlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.ct,
              cost: Math.round(data.ct),
              date: getDate(data.cd),
              costOfInternalFailures: Math.round(data.ci),
              costOfExternalFailures: data.cce,
              costOfPreventiveInvestment: data.cp,
              costOfAppraisal: data.ca,
              costOfotherInvestment: data.crh
            }
          });

          setCostsData(prevData => ({
            ...prevData,
            yearly: costYearlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            yearly: { min: 0, max: 12 }
          }));

          if (chart?.series != undefined && costYearlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[1]?.options?.data : [];
            // newData = [...existingData, costYearlyData[costYearlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costYearlyData[costYearlyData.length - 1].x) {
                  existingData[index] = costYearlyData[costYearlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costYearlyData[costYearlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[1]?.setData(newData);
          }
          (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({
            min: 0,
            max: 12
          });
          (costYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        default:
          break;
      }
      // setDataLabel((simObj?.graphdata != undefined) ? simObj?.graphdata : []);
    }
  }

   function applyAccessibility(chart) {
      if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
          svg.setAttribute("role", "img");
          svg.setAttribute(
          "aria-label",
          "Revenue and Cost of Quality chart showing daily revenue compared to quality-related costs for the current month."
          );

          const oldDesc = svg.querySelector("desc");
          if (oldDesc) oldDesc.remove();

          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
          "This area and line chart tracks revenue and cost of quality for each day of the current month. The x-axis represents the days of the month from 1 to 30, while the y-axis shows dollar values.";
          svg.insertBefore(desc, svg.firstChild);
        },0);
      }
      }
  }

  const formatterFun = (type) => {

    switch (type) {
      case "monthly":
        return function () {
          return `
          <div className=${`${QmModuleStyle.tooltip}`}>
          <div>Day: ${this.point.date}</div>
          ${(this.point.revenue != undefined) ? `<div>Revenue: $${this.point.revenue}</div>` : ``}
          ${(this.point.cost != undefined) ? `<div>Cost: $${this.point.cost}</div>` : ``}
          ${(this.point.costOfInternalFailures != undefined) ? `<div>Internal Failure: $${this.point.costOfInternalFailures}</div>` : ``} 
          ${(this.point.costOfExternalFailures != undefined) ? `<div>External Failure: $${this.point.costOfExternalFailures}</div>` : ``}
          ${(this.point.costOfPreventiveInvestment != undefined) ? `<div>Preventive Investment: $${this.point.costOfPreventiveInvestment}</div>` : ``} 
          ${(this.point.costOfAppraisal != undefined) ? `<div>Appraisal Investment: $${this.point.costOfAppraisal}</div>` : ``} 
          ${(this.point.costOfotherInvestment != undefined) ? `<div>Other Investments: $${this.point.costOfotherInvestment}</div>` : ``}
          </div>
          `;
        };
      case "quarterly":
        return function () {
          return `
          <div className=${`${QmModuleStyle.tooltip}`}>
          <div>Day: ${this.point.date}</div>
          ${(this.point.revenue != undefined) ? `<div>Revenue: $${this.point.revenue}</div>` : ``}
          ${(this.point.cost != undefined) ? `<div>Cost: $${this.point.cost}</div>` : ``}
          ${(this.point.costOfInternalFailures != undefined) ? `<div>Internal Failure: $${this.point.costOfInternalFailures}</div>` : ``} 
          ${(this.point.costOfExternalFailures != undefined) ? `<div>External Failure: $${this.point.costOfExternalFailures}</div>` : ``}
          ${(this.point.costOfPreventiveInvestment != undefined) ? `<div>Preventive Investment: $${this.point.costOfPreventiveInvestment}</div>` : ``} 
          ${(this.point.costOfAppraisal != undefined) ? `<div>Appraisal Investment: $${this.point.costOfAppraisal}</div>` : ``} 
          ${(this.point.costOfotherInvestment != undefined) ? `<div>Other Investments: $${this.point.costOfotherInvestment}</div>` : ``}
          </div>
          `;
        };
      case "yearly":
        return function () {
          return `
          <div className=${`${QmModuleStyle.tooltip}`}>
          <div>Day: ${this.point.date}</div>
          ${(this.point.revenue != undefined) ? `<div>Revenue: $${this.point.revenue}</div>` : ``}
          ${(this.point.cost != undefined) ? `<div>Cost: $${this.point.cost}</div>` : ``}
          ${(this.point.costOfInternalFailures != undefined) ? `<div>Internal Failure: $${this.point.costOfInternalFailures}</div>` : ``} 
          ${(this.point.costOfExternalFailures != undefined) ? `<div>External Failure: $${this.point.costOfExternalFailures}</div>` : ``}
          ${(this.point.costOfPreventiveInvestment != undefined) ? `<div>Preventive Investment: $${this.point.costOfPreventiveInvestment}</div>` : ``} 
          ${(this.point.costOfAppraisal != undefined) ? `<div>Appraisal Investment: $${this.point.costOfAppraisal}</div>` : ``} 
          ${(this.point.costOfotherInvestment != undefined) ? `<div>Other Investments: $${this.point.costOfotherInvestment}</div>` : ``}
          </div>
          `;
        };
      default:
        return null;
    }

  }

  const xAxis = {
    "monthly": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      tickLength: 0,
      crosshair: {
        snap: false,
        width: 1,
        color: '#C9C8B9',
        zIndex: 5
      },
      accessibility: {
        point: {

        }
      },
      title: {
        text: "Day of Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.6em'
        }
      }

    },
    "quarterly": {
      categories: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      // max:3,
      tickmarkPlacement: 'on',
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      tickLength: 0,
      title: {
        text: "Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      rangeSelector: {
        selected: 1
      },
      accessibility: {
        point: {

        }
      },
      crosshair: {
        snap: false,
        width: 1,
        color: '#C9C8B9',
        zIndex: 5
      }
    },
    "yearly": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 3,
      tickLength: 0,
      title: {
        text: "Quarter",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      accessibility: {
        point: {

        }
      },
      categories: ['', '', '', 'Q1', '', '', 'Q2', '', '', 'Q3', '', '', 'Q4'],
      tickmarkPlacement: 'on',
      crosshair: {
        snap: false,
        width: 1,
        color: '#C9C8B9',
        zIndex: 5
      }
    }
  }
  const yAxis = {
    "monthly": {
      //min: 0,
      // max: 10000000,
      // offset: -10,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      startOnTick: true,
      color: 'rgb(255,255,255)',
      title: {
        text: "Revenue/Cost of Quality",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }

      },

    },
    "quarterly": {
      //min: 0,
      // max: 10000000,
      maxPadding: 0.1,
      tickInterval: null,
      startOnTick: true,
      tickAmount: 6,
      color: 'rgb(255,255,255)',
      title: {
        text: "Revenue/Cost of Quality",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }
      }
    },
    "yearly": {
      //min: 0,
      // max: 10000000,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      startOnTick: true,
      title: {
        text: "Revenue/Cost of Quality",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }
      }

    }
  }
  graphSettings = {
    plotOptions: {
      events: {
        legendItemClick: function () {
          return false; // Prevent default legend item click behavior
        }
      },
      series: {
        stickyTracking: true,
        marker: {
          enabled: true,
        },
        pointPlacement: "on",
        states: {
          inactive: {
            enabled: false
            //opacity:1
          },
          hover: {
            halo: {
              size: 7,
              opacity: 0.5,
            },

          }
        }
      }
    },
    chart: {
      type: "area",
      responsive: false,
      marginRight: 15,
      // marginTop: 3,
      height: 200,
      plotBorderWidth: 1,
      panning: type === "quarterly",
      events: { 
        render: function () {
            applyAccessibility(this);
        },
        redraw: function () {
            applyAccessibility(this);
        }
      }
    },
    title: null,
    legend: {
      enabled: false,
      align: 'left',
      verticalAlign: 'top',
      // floating: true,
      visible: true,
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '12px'
      }
    },
    xAxis: xAxis[type],
    yAxis: yAxis[type],
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `Day: ${point.date}; ${(point.revenue != undefined) ? `Revenue: $${point.revenue};` : ``} ${(point.cost != undefined) ? `Cost: $${point.cost};` : ``} ${(point.costOfInternalFailures != undefined) ? `Internal failure: $${point.costOfInternalFailures};` : ``} ${(point.costOfExternalFailures != undefined) ? `External failure: $${point.costOfExternalFailures};` : ``} ${(point.costOfPreventiveInvestment != undefined) ? `Preventive investment: $${point.costOfPreventiveInvestment};` : ``} ${(point.costOfAppraisal != undefined) ? `Appraisal investment: $${point.costOfAppraisal};` : ``} ${(point.costOfotherInvestment != undefined) ? `Other Investments: $${point.costOfotherInvestment}` : ``}`;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }  
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Revenue",
        lineWidth: 2,
        data: [],
        color: "#337B8D",
        //fillColor: "#D1DFE2",
        // fillColor: {
        //   pattern: {
        //     color: '#353d6e'
        //   }
        // },
        fillColor: {
          pattern: {
            path: {
              // diagonal stripes
              d: 'M 0 0 L 6 6 M -3 3 L 3 9 M 3 -3 L 9 3',
              strokeWidth: 1
            },
            width: 6,
            height: 6,
            color: '#337B8D'
          }
        },
        marker: {
          enabled: type === "monthly",
          radius: 2,
        },
        dataLabels: {
          enabled: false // Disable data labels for this series
        }
        /*states: {
          hover: {
            enabled: type === "monthly" || "quarterly" || "yearly"
          }
        }*/
      },
      {
        name: "Cost of Quality",
        lineWidth: 2,
        data: [],
        color: "#9a5712",
        //fillColor: "#FBE4D4",
        // fillColor: {
        //   pattern: {
        //     color: '#e6151f'
        //   }
        // },
        fillColor: {
          pattern: {
          path: {
            d: 'M 6 0 L 0 6 M 3 -3 L 9 3 M -3 3 L 3 9',
            strokeWidth: 1
          },
            width: 6,
            height: 6,
            color: '#9a5712'
          }
        },
        marker: {
          //symbol: "circle",
          enabled: type === "monthly", // Enable markers only for "monthly" type
          radius: 2,
          //radius: 3,
        },
        dataLabels: {
          enabled: false // Disable data labels for this series
        }
        /*states: {
          hover: {
            enabled: type === "monthly" || "quarterly" || "yearly"
          }
        }*/
      }
    ],
    tooltip: {
      enabled: (isResult != undefined && isResult) ? false : true,
      shared: false,
      useHTML: true, // Enable HTML content in tooltip
      hideDelay: 0,
      headerFormat: '',
      formatter: formatterFun(type),
      style: {
        color: '#fff'
      },
      valueDecimals: 0,
      backgroundColor: '#000',
      borderColor: '#000',
      borderRadius: 0,
      borderWidth: 3,
    }

  }


  useEffect(() => {
    const newChart = Highcharts.chart("RevenueGraph-Quality", graphSettings);
    newChart.series[0].update({ zIndex: 2, type: "area" });
    newChart.series[1].update({ zIndex: 2, type: "area" });
    setChart(newChart);
    if (type === "monthly" || type === "quarterly" || type === "yearly") {
      const g_container = QmModuleStyle['graph-container'];
      let gContainer = document.getElementsByClassName(`${g_container}`)[0];
      gContainer.setAttribute("tabindex", '-1');
      gContainer.focus();
    }
    //Added for xaxis type quarterly resizable.
    if (type === "quarterly") {
      function updateCategories(type) {
        const categories = type === "quarterly" ?
          (window.innerWidth < 1218 ?
            ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] :
            ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']) :
          [];
        if (newChart && newChart.xAxis && newChart.xAxis[0]) {
          newChart.xAxis[0].update({
            categories: categories
          });
        }
      }
      updateCategories("quarterly");
      window.addEventListener('resize', function () {
        updateCategories("quarterly");
      });
    }
  }, [type]);

  useEffect(() => {
    if (isResult && chart != undefined) {
      chart?.series[0]?.setData([]);
      chart?.series[1]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      setGraphData();
    }
    if (chart != undefined) {
      setRevenueGraphLabel(`Revenue and Cost of quality graph representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval}$ per unit scale and Time quarter along X-axis with 1 quarter per unit scale.`);
      document.querySelector("#RevenueGraph-Quality").setAttribute('role', `figure`);
      document.querySelector("#RevenueGraph-Quality .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.laststate?.graphdata, simObj?.currentstep, summaryGraphData]);
  useEffect(() => {
    if (isResult) {
      setGraphData();
    }
  }, [simObj, isResult, summaryGraphData])
 

  return (
    <div className={`${QmModuleStyle['graph-container']}`} id={type == "monthly" ? "tabpanel-1" : type == "quarterly" ? "tabpanel-2" : "tabpanel-3"} role="tabpanel" aria-labelledby={type == "monthly" ? "tab-1" : type == "quarterly" ? "tab-2" : "tab-3"}>
      {!simObj?.graphdata?.length && <div className={`${QmModuleStyle['nodata-alert-revenue']}`}>Cost of quality will appear here as the simulation runs</div>}
      <span></span>
      <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legends: line with round bullet for Revenue and line with Rhombus got Cost of Quality" className="sr-only"></a>
      <div id="RevenueGraph-Quality" className={`${QmModuleStyle['revenue-graph']}`} aria-label={revenueGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default RevenueGraph